// Layout Constants
export const BOTTOM_TAB_HEIGHT = 56; // Height of bottom navigation bar
export const BOTTOM_CONTENT_PADDING = 80; // Padding to ensure content doesn't get hidden behind bottom tabs

export const APP_NAME = "Saraighat Digital";
export const WHATSAPP_NUMBER = "+919954066643";
export const EMAIL = "dr.sarmah.dilip@gmail.com";
export const APP_VERSION = "8.0.6";
